// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"a4a34f7a","262":"c5b64f76","478":"9e8a4a74","722":"2e38da0e","897":"b34b606d","926":"44269021"}[chunkId] + ".chunk.js";
};